import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewSelectorComponent } from './view-selector.component';
import {
	MatChipsModule,
	MatIconModule,
	MatMenuModule,
	MatTooltipModule,
	MatDividerModule,
	MatButtonModule
} from '@angular/material';

@NgModule({
	declarations: [ViewSelectorComponent],
	imports: [
		MatChipsModule,
		MatIconModule,
		MatMenuModule,
		MatTooltipModule,
		MatDividerModule,
		MatButtonModule,
		CommonModule
	],
	exports: [ViewSelectorComponent]
})
export class ViewSelectorModule {}
